import { routeConfig } from "./routeConfig.js";
import { GroupKey, MemberKey, OrgKey } from "@zickko/shared";
export namespace portalRoutes {
  export const home = routeConfig<{}, {}>("/");
  // export const profile = routeConfig<{}, {}>(`/profile`);

  export namespace orgs {
    export const home = routeConfig<{}, {}>(`/orgs`);
    export const create = routeConfig<{}, {}>(`${orgs.home.template}/create`);
    export const select = routeConfig<{}, {}>(`${orgs.home.template}/select`);

    export namespace org {
      export const home = routeConfig<{}, {}>(`${orgs.home.template}/:orgId`);
      export const view = routeConfig<OrgKey, {}>(`${org.home.template}/view`);
      export const edit = routeConfig<OrgKey, {}>(`${org.home.template}/edit`);
      export const dashboard = routeConfig<OrgKey, {}>(`${org.home.template}/dashboard`);

      export namespace members {
        export const home = routeConfig<OrgKey, {}>(`${org.home.template}/members`);
        export const list = routeConfig<OrgKey, {}>(`${members.home.template}/list`);
        export const create = routeConfig<OrgKey, {}>(`${members.home.template}/create`);
        export const edit = routeConfig<MemberKey, {}>(`${members.home.template}/edit/:uid`);
        export const view = routeConfig<MemberKey, {}>(`${members.home.template}/:uid`);
      }

      export namespace groups {
        export const home = routeConfig<OrgKey, {}>(`${org.home.template}/groups`);
        export const list = routeConfig<OrgKey, {}>(`${groups.home.template}/list`);
        export const create = routeConfig<OrgKey, {}>(`${groups.home.template}/create`);
        export const edit = routeConfig<GroupKey, {}>(`${groups.home.template}/edit/:groupId`);
        export const view = routeConfig<GroupKey, {}>(`${groups.home.template}/:groupId`);
      }
    }
  }
}
